import React, { Component } from 'react';
import { connect } from 'react-redux';
import './PaymentSuperFund.css';
import { getWebViewHtml } from '../action/webViewContentAction.js';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { Toast } from 'antd-mobile/lib';
import Util from "../util.js";
import { signSuperFundAccAgreement } from '../action/investmentAction';
import { getStorage } from '../common.js';

class SuperFundSigning extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    let {dispatch}=this.props;
    let params=this.props.location.state
    // dispatch(getWebViewHtml(params, ()=>{this.succallback()}, (msg)=>{this.errcallback(msg)}));
    // document.title =this.props.location.state.name
    
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }
 async signSuperAccAgreement(){
    let userInfo=await getStorage('currentUserInfo');
    let userMsg = userInfo.userMsg;
    if(userMsg && userMsg.certType != "0"){
        Toast.info('为了保障您的交易体验，投顾服务暂不支持非身份证用户签约/投资。', Util.ToastTime);
        return;
      }
      if(userMsg && new Date().getTime()-userMsg.birthday < 568080000000) {
        Toast.info('为了保障您的交易体验，投顾服务暂不对18周岁以下用户开放。', Util.ToastTime);
        return;
      }
    this.props.dispatch(signSuperFundAccAgreement(
      {state:1,operator:"user"},(e)=>{
          Toast.hide()
          console.log(e,"签约成功///////")
          Toast.info( "签约成功", Util.ToastTime );
          setTimeout(()=>{
            hashHistory.goBack()
          },2000 )
          setTimeout(()=>{
              this.props.location.state.callback()
          },2200)
          console.log(this.props.location,"this.props.locationthis.props.location")
      } ))
  }
  handleCancel(){
    hashHistory.goBack()
  }
  render(){
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>{"签约"}</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content ' style={{ background:"#FFF",paddingBottom:45 }}>
            <div className='qy_read_title'>
              请您阅读并同意以下内容：
            </div>
            <div style={{ padding:13 }} className="qy_read_content">
                <p>
                上海华夏财富投资管理有限公司
                </p>
                <p>
基金投资顾问服务协议
</p>
 
<p>
甲方：投资者
                </p>
                <p>
乙方：上海华夏财富投资管理有限公司
</p>
 
<p>
根据《中华人民共和国证券投资基金法》（以下简称“《证券投资基金法》”）、《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》（中国证券监督管理委员会机构部函[2019]2515号）（以下简称“《通知》”）等有关法律法规和规范性文件的规定，甲方自愿申请使用乙方基金投资顾问服务，为明确双方的权利和义务，经双方友好协商，签订本协议。本协议通过乙方平台或其指定的基金销售机构平台以电子方式签署，甲方可通过“勾选”、点击“同意签约”或个人电子签名等方式与乙方书面签署本协议。
</p>
 
<p>
第一章 风险揭示及免责
</p>

<p>
第一条 风险揭示
</p>

<p>
基金投资顾问为乙方接受甲方委托，按照约定向投资者提供的根据投资者个人情况提供投资建议并构建投资组合及投资交易的投资顾问服务工具，其实质为购买特定投资组合所包含的公募基金产品或中国证监会认可的其他产品（以下简称“成份基金”）。
</p>
<p>
请甲方务必于申请使用基金投资顾问服务之前，认真、全面、细致地阅读本协议、乙方及基金投顾组合中成份基金的销售机构（以下简称“成份基金销售机构”）（如有）的业务规则（包括但不限于与基金投资顾问服务的业务规则、资金交收规则等）及基金投顾组合《风险揭示书》、《组合策略说明书》，充分了解基金投资顾问业务规则、收费方式、免责情形等内容。若甲方不接受本协议当中任何条款、乙方及成份基金销售机构的业务规则及《风险揭示书》、《组合策略说明书》中的任何内容，请勿进行“勾选”、点击“同意签约”或其他方式电子签署本协议，亦不得使用本协议约定的基金投资顾问服务。甲方不得以未仔细阅读本协议、乙方及成份基金销售机构的业务规则及《风险揭示书》、《组合策略说明书》的全部或部分约定为由提出相关的权利主张或抗辩。
</p>
<p>
（一）甲方应当结合自身的投资经历、风险承受能力、资产配置需要、流动性需求等特征，自主决策使用基金投资顾问服务并独立承担投资风险。
乙方从事基金投资顾问业务，应当遵守法律法规和中国证监会的相关规定，遵循诚实信用原则，防范利益冲突，切实维护甲方的合法权益，勤勉、审慎地为甲方提供服务。虽然乙方已经在中国证券监督管理委员会备案，具有从事基金投资顾问业务的试点资格，但该备案不构成对投资顾问机构投资能力、持续合规情况的认可，不作为对基金财产安全的保证。基金投资顾问业务尚处于试点阶段，存在因乙方试点资格被取消不能继续提供服务的风险。
</p>
<p>
（二）甲方使用基金投资顾问服务，将视为甲方授权乙方行使约定权限的账户管理权，授权乙方自行向成份基金管理人出具成份基金认/申购、赎回、转换等交易指令以及投顾服务费划款（或基金份额过户），代甲方向成份基金销售机构出具成份基金认/申购、赎回、转换等交易指令以及投顾服务费划款（或基金份额过户）指令，乙方将根据既定的投资策略和组合构建程序提出投资顾问建议，授权乙方按照相关流程和规范帮助甲方构建投资组合（包括但不限于成份基金的认/申购、赎回、转换、调仓等）。甲方使用乙方提供的基金投资顾问服务，应缴纳一定比例的投资顾问服务费。甲方认可乙方制定的计费标准及收费规则，同意乙方或成份基金销售机构计算应向甲方收取的基金投顾服务费，通过投顾服务费划款（或基金份额过户）等监管认可的方式实现投资顾问服务费的收取。
</p>
<p>
（三）甲方基金投资顾问账户下的投资组合，实质是按照投资建议的资产分配比例，一次性认/申购该投资组合内的所有成份基金。甲方在使用基金投资顾问服务前，应当知悉投资组合的风险，仔细阅读并签署风险揭示书。
</p>
<p>
（四）投资组合内成份基金的风险一般包括因整体政治、经济、社会等环境因素对证券价格产生影响而形成的系统性风险，个别证券特有的非系统性风险，由于基金投资者连续大量赎回基金产生的流动性风险，基金管理人在基金管理实施过程中产生的基金管理风险，成份基金的特定风险等等。投资组合内各成份基金的具体情况可参见《基金合同》、《招募说明书》、《发售公告》等法律文件，基金投资组合策略的风险特征与单只基金产品的风险特征存在差异。
</p>
<p>
（五）为了方便甲方使用基金投资顾问服务，乙方将对投顾账户的签约与解约以及投资组合的认/申购、赎回、调仓、分红等业务设定特定的业务规则，甲方应该充分了解并接受乙方及成份基金销售机构的业务规则，否则甲方不得通过乙方使用基金投资顾问业务。乙方有权根据业务开展情况，对基金投资顾问服务进行升级、改进，甚至暂停基金投资顾问服务，相关变化应及时向甲方履行披露义务。
</p>
<p>
（六）为帮助甲方制定投资决策，乙方设计了教育、养老等情景下的投资规划模拟并出具投资方案建议，该模拟是使用市场中具有代表性的指数中长期的历史年化平均收益率计算，未来由于市场环境不同、实际投资运作等不可能完全复制其模拟结果。该模拟不作为投资预测，也不代表投资者实际投资所得收益，投资也可能遭遇亏损。
</p>
<p>
第二条 免责条款
</p>
<p>
（一）基金投资顾问服务由乙方根据一定的投资策略或投资目标提供，乙方不对建议配置的投资组合进行任何实质的判断，不保证投资组合一定盈利。资本市场的发展无法预测，组合过往业绩并不预示其未来表现。乙方不对基金收益状况或本金不受损失作出任何承诺，甲方通过投资顾问服务进行的基金投资仍然存在投资亏损的风险，投资者需自行承担。
</p>
<p>
（二）任何投资都可能产生损失，乙方选择的特定成份基金可能在一段时间内的收益率情况较差。
</p>
<p>
（三）乙方受理甲方基金投资顾问业务申请，不代表甲方发起的一系列具体交易（投资组合构建、调仓等）一定成功，各项业务可能受基金注册登记机构业务规则或成份基金销售机构业务规则影响而全部失败或者部分失败，具体情形包括但不限于暂停申购、暂停赎回、申购限额、赎回限额、巨额赎回、暂停定期定额投资等，乙方及成份基金销售机构无需对业务失败承担任何责任。
</p>
<p>
（四）为了便于甲方了解投资组合的整体投资表现，乙方将模拟计算投资组合的净值、损益等数据，该等数据仅供甲方参考，不构成甲方实际投资收益证明或作为任何形式的证据使用，甲方实际投资损益以投资组合成份基金的基金管理人披露数据为准。
</p>
<p>
（五）乙方及成份基金销售机构将定期或不定期通过短信、邮件、乙方自有线上平台内部信息推送方式中的至少一种方式向甲方推送基金投资顾问业务运作信息，但不保证一定送达。
</p>
<p>
（六）如遇自然灾害等不可抗力事件，或其他不可预见的非常情况，或网络、通讯故障发生等，导致乙方及成份基金销售机构无法履行协议的，乙方及成份基金销售机构不承担任何责任。
 
</p>
<p>
第二章 协议条款
</p>
<p>
第一条 定义
</p>
<p>
基金投资顾问：指乙方接受甲方委托，按照本协议约定向甲方提供基金投资组合建议，代甲方做出具体基金投资品种、数量和买卖时机的决策，由乙方或乙方通过成份基金销售机构代甲方执行成份基金认/申购、赎回、转换等交易申请（含通过乙方或成份基金销售机构指定的货币市场基金进行操作），并直接或间接获取经济利益（如投资顾问服务费）的基金投资顾问。
</p>
<p>
成份基金销售机构：指与乙方签署合作协议并按照该协议约定及有关业务规则（包括但不限于乙方与成份基金销售机构自身的业务规则及乙方与成份基金销售机构合作业务规则），为甲方开立基金交易账户，接受乙方操作指令，代甲方执行成份基金认/申购、赎回、转换等交易申请（含通过乙方或成份基金销售机构指定的货币市场基金进行操作），向甲方提供相关服务的基金销售机构。
</p>
<p>
投顾账户开立：指甲方与乙方签署基金投资顾问服务协议，授权乙方为甲方开立进行基金投资顾问服务的基金交易账户，并行使约定权限的账户管理权；或授权与乙方合作的成份基金销售机构为甲方开立的基金交易账户（如需），授权乙方向成份基金销售机构发送对应操作指令，由成份基金销售机构按照与乙方签署的合作协议的约定及有关业务规则（包括但不限于乙方自身业务规则、成份基金销售机构自身业务规则及乙方与成份基金销售机构合作业务规则）对基金交易账户进行操作。甲方按基金销售有关规定开立的基金交易账户作为其基金投资顾问业务的授权账户。乙方根据甲方的授权在乙方或乙方指定的成份基金销售机构系统标识甲方投资组合对应的投顾账户。
</p>
<p>
投资组合：指由乙方根据一定的投资策略或投资目标构建的，由若干只公募基金产品或中国证监会认可的其他产品构成的资产组合，包括投资范围、投资限制、投资策略、业绩比较基准、投顾服务费率等。投资者在选择具体的基金投资组合策略前，应仔细阅读《组合策略说明书》，《组合策略说明书》属于本协议的组成部分。投资组合本身并非任何形式的产品或集合投资计划。
</p>
<p>
成份基金：指投资组合所包含的所有公募基金产品或中国证监会认可的其他产品，根据特定的投资策略或者投资目标，乙方可能定期或不定期对投资组合的成份基金或者成份基金的资产配置比例做出调整。
</p>
<p>
组合购买：指甲方通过乙方自有平台或乙方合作的成份基金销售机构平台购买投资组合，实质是授权乙方按照甲方选择的基金投资组合策略，代甲方做出具体基金投资品种、数量和购买时机交易决策，按照投资组合预设的资产配置比例，通过乙方或代甲方向成份基金销售机构出具基金产品认/申购指令一次性认/申购投资组合内所有的成份基金。
</p>
<p>
组合赎回：指甲方通过乙方自有平台或乙方合作的成份基金销售机构通过乙方或代甲方向成份基金销售机构出具成份基金赎回指令，对已持有投资组合内的成份基金进行全部或者按比例赎回。
</p>
<p>
组合调仓：指甲方授权乙方对甲方已持有投资组合向目标投资组合进行调整的行为，实质是针对组合中的一系列成份基金进行认/申购、赎回或转换，乙方可向成份基金销售机构发出相关指令实现相关行为。
</p>
<p>
净投资额：指甲方初始投资额加上历次认/申购、赎回轧差金额后的价值。
</p>
<p>
工作日：指上海证券交易所、深圳证券交易所的正常交易日。
</p>
<p>
投资顾问服务费：是指乙方根据所提供的基金投资顾问服务收取的一定费用。
</p>
<p>
服务运作期：指乙方接受甲方委托，向甲方提供基金投资顾问服务的期限（如有）。具体时间见《组合策略说明书》。
</p>
<p>
第二条 当事人的权利义务
</p>
<p>
（一）甲方的权利义务
</p>
<p>
1、甲方的权利
</p>
<p>
（1）甲方有权要求乙方根据本协议的约定，办理投顾账户开立、基金交易账户开立、组合购买、组合调仓、成份基金的认/申购、赎回、转换、分红等有关基金投资顾问业务，乙方向成份基金销售机构发出相关指令以完成上述基金投资顾问相关行为。
</p>
<p>
（2）其他法律法规、规范性文件规定及本协议约定甲方应享有的义务。
</p>
<p>
2、甲方的义务
</p>
<p>
（1）认真阅读并遵守本协议、乙方及成份基金销售机构的业务规则及《风险揭示书》、《组合策略说明书》，明确知悉并承担基金组合投资的风险；
</p>
<p>
（2）认真阅读并签署《风险揭示书》；
</p>
<p>
（3）充分全面了解本协议及《组合策略说明书》约定的基金组合策略，如实填写风险识别和承担能力调查问卷，告知相关信息，并对其真实性、准确性和完整性负责，前述信息如发生实质性变更，应及时告知乙方或其指定其他基金销售机构；
</p>
<p>
（4）以真实身份和自有资金参与基金投资顾问服务，保证资金来源符合国家有关规定；
</p>
<p>
（5）按照本协议的约定（收费项目、收费标准和支付方式等），缴纳参与款项，并支付相关投资顾问服务费（如有）及成份基金收取的有关交易费用。
</p>
<p>
（6）甲方应明确知悉其是与投资顾问服务项下基金组合策略的风险等级进行适当性匹配，基金组合策略中可能会有个别基金与甲方的投资风险承受能力不匹配，甲方在此不可撤销地承认并同意乙方可根据其资产配置策略为客户配置该等基金。
</p>
<p>
（7）甲方确认投资顾问服务账户项下基金组合中的任一基金召开基金份额持有人大会，即构成甲方已按照本协议约定不可撤销地授权乙方出席相应的基金份额持有人大会并代甲方行使表决权。
</p>
<p>
（8）甲方应根据本协议的约定及乙方和成份基金销售机构业务规则，全权授权乙方和成份基金销售机构办理投顾账户开立、基金交易账户开立、组合购买（含失败业务处理）、组合调仓（含失败业务处理）、成份基金的认/申购、赎回、转换、分红、投资顾问服务费收取（含通过乙方或成份基金销售机构指定的货币市场基金进行操作）等有关基金投资顾问业务，不干涉且不撤销投资顾问做出的调仓指令。
</p>
<p>
（9）其他法律法规、规范性文件及本协议约定甲方应尽的义务。
</p>
<p>
（二）乙方的权利义务
</p>
<p>
1、乙方的权利
</p> <p>
（1）乙方有权根据本协议的约定及自身业务规则，为投资者提供基金投资组合建议，代甲方办理投顾账户开立、基金交易账户开立，组合购买（含失败业务处理）、组合调仓（含失败业务处理）、成份基金的认/申购、赎回、转换、分红、投资顾问服务费收取等有关基金投资顾问业务涉及的交易申请（含通过乙方或成份基金销售机构指定的货币市场基金进行操作），通过乙方或其指定的成份基金销售机构执行前述交易指令。
</p> <p>
（2）乙方有权根据本协议的约定，按照与成份基金销售机构签署的合作协议的约定及有关业务规则（包括但不限于乙方自身业务规则、成份基金销售机构自身业务规则及乙方与成份基金销售机构合作业务规则），代甲方向成份基金销售机构出具成份基金认/申购、赎回、转换等交易指令以及投顾服务费划款（或基金份额过户）指令，相关交易指令或划款（或基金份额过户）指令的执行结果由投资者自行承担。
</p> <p>
（3）乙方有权根据本协议约定的收费项目、收费标准和支付方式，向甲方收取投资顾问服务费（如有）及成份基金收取的有关交易费用。
</p> <p>
（4）其他法律法规、规范性文件及本协议约定乙方应享有的权利。
</p> <p>
2、乙方的义务
</p> <p>
乙方从事基金投资顾问服务，应当恪尽职守，履行诚实信用、谨慎勤勉的义务。维护投资行业的完整性，优先维护投资者的利益。遵守自愿、公平、诚实信用的基本原则，不得利用自身优势地位损害投资者利益。
</p> <p>
乙方应根据本协议的约定及自身业务规则，或根据与成份基金销售机构签署的合作协议的约定，代甲方办理投顾账户开立、基金交易账户开立、组合购买、组合调仓、成份基金的认/申购、赎回、转换、分红等有关基金投资顾问业务，或通过成份基金销售机构代甲方办理基金交易账户开立、组合购买、组合调仓、成份基金的认/申购、赎回、转换、分红等有关基金投资顾问业务。
</p> <p>
在乙方首次接触普通投资者并向其提供服务前，乙方应当提示甲方可以通过录音、截屏等方式留存相关信息。通过互联网在线方式提供投资顾问服务的，应当向甲方提供记录、保存、下载等留痕功能。
</p> <p>
乙方提示甲方注意任何实际或潜在的利益冲突。乙方应尽合理的注意义务和独立的专业判断进行投资分析，出具投资建议，采取投资行为和从事其他专业活动。维护资本市场相关规则，遵守相关法律法规，维护并提高自身专业能力。
</p> <p>
为保证甲方合法权益，乙方应当建立健全基金投资顾问业务管理制度、合规管理和风险控制机制，了解甲方的身份、财产与收入状况、证券投资经验、投资需求与风险偏好，评估甲方的风险承受能力，乙方应当了解甲方的情况，在评估风险承受能力和服务需求的基础上，向甲方提供适当的投资建议服务。乙方应当通过自身平台或成份基金销售机构平台向甲方进行风险揭示，进行业务推广时不得对其服务能力和过往业绩进行虚假、不实、误导性的营销宣传，不得以任何方式向甲方承诺或者保证收益。
</p> <p>
乙方的其他义务包括：
</p> <p>
（1）以诚实信用、谨慎勤勉的原则管理组合财产；
</p> <p>
（2）配备足够的具有专业资格的人员进行基金投资分析、决策，以专业化的经营方式管理投顾账户；
</p> <p>
（3）建立健全内部风险控制、监察与稽核、财务管理及人事管理等制度，保证所管理的组合财产和乙方的财产相互独立，单独对投顾业务下的投资组合进行登记和管理；
</p> <p>
（4）除法律法规、本协议及其他有关规定外，不得利用组合财产为自己及任何第三人谋取利益，不得委托第三人进行账户管理；
</p> <p>
（5）严格按照法律法规及其他有关规定，履行信息披露义务；
</p> <p>
（6）保守基金商业秘密，不泄露投资者的投资计划、投资意向等。除法律法规及其他有关规定另有规定外，在组合信息公开披露前应予保密，不向他人泄露。
</p> <p>
第三条 服务内容与方式
</p> <p>
（一）业务规则
</p> <p>
甲方通过乙方平台或乙方指定的成份基金销售机构使用基金投资顾问服务，同意按下列规则办理：
</p> <p>
1、授权委托：甲方同意按照本协议及其附件（如有），接受乙方提供的基金投资顾问服务，委托并授权乙方运用甲方交纳的约定参与款代甲方作出投资决策、发布调仓指令并通过基金投资顾问账户执行相关指令来进行证券投资基金投资。甲方同意基金投资顾问账户项下各基金的红利分配方式为红利再投资方式（“小常乐目标盈”止盈智投系列投资组合各成份基金的红利分配方式以组合策略说明书约定为准）。乙方同意接受甲方的委托和授权，按照本协议及其附件（如有）的约定，向甲方提供基金投资顾问服务，将甲方交纳的约定参与款投资于乙方或其指定的成份基金销售机构销售的公募基金及监管机构允许的其他产品。
</p> <p>
2、适用范围：本服务一般可适用于法律法规或监管规定允许乙方提供基金投顾服务的各类产品，但具体适用的产品范围以乙方页面及乙方认可的成份基金销售机构页面展示为准，乙方有权根据业务需要变更本服务适用的基金投资组合所投资的公募基金产品或中国证监会认可的其他产品的范围。
</p> <p>
3、服务申请：甲方参与和退出基金投资顾问服务的业务申请可通过乙方或其指定的成份基金销售机构办理。甲方应在工作日15:00前向乙方或其指定基金销售机构提出上述业务申请，甲方在工作日15:00以后或非工作日提出的申请，将被视为下一个工作日提出的申请。甲方参与基金投资顾问服务时，需在乙方或其指定的成份基金销售机构开立基金投资顾问账户。投资组合中任一成份基金处于暂停申购状态时，乙方有权自行或通过成份基金销售机构针对该组合不接受组合购买服务申请；投资组合中任一成份基金处于暂停赎回状态时，乙方有权自行或通过成份基金销售机构针对该组合不接受组合全部或部分成份基金赎回服务申请，如不接受部分成份基金赎回服务申请的，则该部分成份基金对应资产冻结，当日甲方可赎回总资产为实际资产减去此部分冻结资产，具体详情以乙方页面及乙方认可的成份基金销售机构页面展示为准。
</p> <p>
4、组合策略：由乙方负责提供组合的资产配置方案，并根据市场和组合运行情况，实时进行调整。乙方将根据甲方的特征信息，例如年龄、性别、收入、资产状况、投资目标等，在满足投资品种和流动性要求等投资限制的前提下，协助甲方设定符合甲方需求的投资目标。乙方将研发资产配置模型，通过对客户风险偏好、投资目标的量化，对各类资产给予不同的权重，力争使组合长期收益符合客户预期。甲方可以选取的具体组合策略及相应风险控制措施内容请参考乙方统一制定的基金投资组合策略说明书。
</p> <p>
5、基金投资顾问服务资金账户、缴款方式：
除《组合策略说明书》、《上海华夏财富投资管理有限公司基金投资顾问服务电子交易定期定额申购业务协议》及乙方指定成份基金销售机构相关业务规则另有约定外，甲方支付约定参与款、申请退出后获得退出款等均通过乙方或其指定的成份基金销售机构结算账户与甲方本人银行结算账户之间封闭划转，甲方开立基金投资顾问账户时绑定的个人银行结算账户是甲方接受基金投资顾问服务而交纳参与资金、投资顾问账户项下基金交易所涉资金收付及收取退出基金投资顾问服务时的资金的唯一资金账户。参与款交款方式分为灵活交款方式和定期定额交款方式，具体以《组合策略说明书》、《上海华夏财富投资管理有限公司基金投资顾问服务电子交易定期定额申购业务协议》及乙方指定成份基金销售机构有关业务规则的约定为准，除本协议另有约定外，甲方在提交参与或追加申请时，应全额交付约定参与款。甲方向乙方或其指定的成份基金销售机构提交申请并全额交付款项的，申请方为有效。约定参与款的支付时间、方式以乙方或其指定的成份基金销售机构的业务规则规定为准。
</p> <p>
6、组合调仓：为适应市场变化和投资目标需要，乙方将对甲方的授权账户进行组合调仓，除乙方及乙方合作的成份基金销售机构业务规则另有约定，乙方及乙方合作的成份基金销售机构将根据业务规则实际执行成份基金有关交易指令，无需在每次调仓前获得甲方同意。甲方理解并同意，因乙方的投资判断或跟随目标组合操作的时间差等原因，会导致跟随投资业绩的差异甚至是反差，甲方应自行承担风险和责任。
组合调仓视为同意授权乙方系统根据甲方已持有资产情况向目标成份调整而生成的一系列调仓指令（基金赎回、认/申购、转换、设置基金分红方式等）并自动执行，乙方亦可向通过成份基金销售机构发出有关交易指令实现调仓行为，这些指令从乙方发起到确认完成根据不同的成份基金与指令类型需要若干个交易日。若乙方对甲方的授权账户进行组合调仓时，为达成甲方调整较优配置比例的目标，甲方持有投资组合中的某项或某几项成份基金赎回金额超出该成份基金管理人规定的限额，乙方可以通过乙方系统及成份基金销售机构销售系统根据乙方业务规则为甲方将上述调仓分拆成多笔交易；因认/申购金额超出该成份基金管理人规定的限额的，乙方可以通过乙方系统及成份基金销售机构销售系统根据乙方业务规则为甲方将上述调仓分拆成多笔交易，或认/申购符合该基金投资组合策略的备选基金。若采用分拆多笔交易方式，该多笔交易可能需要若干个交易日。由于基金申购、赎回等操作基于未知价原则，且可能存在申购备选基金的情形，组合调仓即使指令全部执行成功也可能出现与目标组合成份比例有一定偏离的情况。甲方同意上述情形并自行承担风险和责任。
</p> <p>
7、分红方式：为便于投资组合管理，除“小常乐目标盈”止盈智投系列投资组合策略说明书另有约定之外，投资组合内成份基金分红方式将统一设定为红利再投资，且不可以进行修改。甲方签署本协议即表明甲方知晓该业务规则，并授权乙方将组合中各成份基金的分红分配方式统一设置为红利再投资方式（“小常乐目标盈”止盈智投系列投资组合各成份基金的分红分配方式以组合策略说明书约定为准）。
</p> <p>
8、基金投资顾问服务的退出方式（组合赎回）：指通过授权乙方或乙方成份基金销售机构对已持有组合内的所有成份基金进行全部或者按比例赎回。甲方同意并接受，组合部分赎回时，可能会因为各种情形造成组合剩余持仓的成份比例出现一定偏离的情况。甲方同意上述情形并自行承担风险和责任。
</p> <p>
9、巨额赎回：当进行组合赎回或组合调仓时，若发生成份基金巨额赎回且成份基金管理人决定部分延期赎回的情形，甲方同意，对于延期办理的赎回申请部分，授权乙方或成份基金销售机构代甲方选择以连续赎回方式进行赎回。
</p> <p>
10、投资顾问服务费：乙方将按投顾账户中的各类组合的资产净值的一定比例加总收取投资顾问服务费，适用比例乙方将在页面进行展示。乙方可以对投资顾问服务费实施费率优惠，具体优惠费率以乙方页面及乙方认可的成份基金销售机构页面展示为准。在乙方作为成份基金销售机构时，申购、赎回组合中的成份基金时，乙方将在基金销售业务规则允许的情况下，减免甲方计入基金资产外的申购、赎回费用（管理人收取的申购、赎回费用部分不免除）。投资顾问服务费按日计提，以本协议第六条约定的方式收取。
</p> <p>
11、如甲方在使用乙方提供的销售服务中对乙方负有到期债务（包括但不限于因向甲方重复出款、甲方重复赎回份额等导致的甲方不当得利或其他乙方对甲方享有债权的情形），在不影响甲方权益的情况下，经通知甲方后，乙方有权采取包括但不限于冻结甲方交易账户、从甲方银行账户扣款、按照市场价格赎回或过户甲方基金份额等方式来实现债权。
</p> <p>
12、申购费、赎回费、转换费及基金销售费用：基金投资组合策略项下基金的申购费、赎回费、转换费及基金销售等费用，将由甲方承担。
</p> <p>
13、甲方基金投资顾问账户项下的基金因司法执行、行政强制措施、法院判决、离婚等情形，乙方或其指定的成份基金销售机构可根据相关基金的基金合同及基金注册登记机构非交易过户的相关规则协助办理冻结、非交易过户等手续。
</p> <p>
14、基金投资顾问服务电子交易定期定额申购业务：若甲方选择采用定期定额交款方式的缴款参与款，还应签署《上海华夏财富投资管理有限公司基金投资顾问服务电子交易定期定额申购业务协议》或乙方指定成份基金销售机构的相关服务协议并遵守相关约定。
</p> <p>
15、其他本协议未尽的乙方业务规则，以乙方网站公示（包括乙方网站及移动终端（APP）各类交易提示、问答等各种形式的业务规则）为准。其他本协议未尽的成份基金销售机构业务规则以成份基金销售机构为准。甲方应当仔细阅读并了解相关业务规则，甲方申请基金投资顾问服务即表示甲方已经完全清楚、了解并同意乙方及成份基金销售机构的最新业务规则。
</p> <p>
（二）投资建议决策流程
</p> <p>
1、投资目标设定
</p> <p>
乙方或通过成份基金销售机构收集投资者特征信息，例如年龄、性别、收入、资产状况、投资目标等，在满足投资品种和流动性要求等投资限制的前提下，协助投资者设定符合需求的投资目标。
</p> <p>
2、资产配置研究
</p> <p>
乙方将大类资产配置分为战略资产配置和战术资产配置两个层面。战略资产配置的目标是投资组合的长期收益达到客户的预期。乙方在确立战略资产配置比例时，立足长周期，核心聚焦在对大类资产收益和风险的长期预测以及对客户的风险偏好、投资目标的量化。通过对经济增速、货币增速等经济、金融指标判断，实现对大类资产的长期收益和风险预测。通过对客户风险偏好、投资目标的量化，对各类资产给予不同的权重，力争使组合长期收益符合客户预期。
战术资产配置将经济周期对资产的影响纳入资产配置框架，通过在战略资产配置比例上的偏移，获得超额收益。在实践应用中，传统投资时钟忽视了逆周期的政策与资产估值对资产配置的影响。从历史经验看，政策周期对经济周期和对市场波动影响巨大。基于此，母公司华夏基金管理有限公司（“华夏基金”）将投资时钟的分析框架进行完善，形成基于宏观（Macro-economy）、估值（Value）、政策（Policy）的MVP分析模型。乙方基于MVP模型，紧密跟踪宏观数据、估值数据以及政策的变化，定期与华夏基金就大类资产观点进行沟通交流，进行战术资产配置。
</p> <p>
3、基金选择评价
在建立基金备选库过程中，乙方首先会对全市场基金管理人的合规性、基金的持有人结构等条件进行筛选，得到基金备选基础池（基础池）。在基础池的基础之上，对池中基金的策略和管理风格进行划分，通过基金经理访谈和定量分析，重点关注基金的基金规模、投资经理历史业绩、投资风格稳定性、超额收益能力、风险控制能力等要点，选出其中风格明晰、表现持续稳健的基金，并联合乙方母公司华夏基金的投研团队进行调研，反复论证，交叉验证，将评分靠前的基金移入基金备选核心池（核心池）。
</p> <p>
4、组合构建
在底层基金资产的基础上，乙方根据不同的投资目标提供多样化的组合。在组合的分类上，主要基于投资期限和收益目标这两个维度构建组合。
</p> <p>
（三）调仓管理
</p> <p>
甲方同意按照本协议约定，接受乙方提供的授权管理账户服务，委托并授权乙方运用甲方交纳的资金以甲方名义进行组合投资，并授权乙方做出决定。甲乙双方确认，乙方及成份基金销售机构基于本协议约定办理成份基金的认/申购、赎回、转换等交易，应符合法律法规及相应产品合同、招募说明书、临时公告等文件的规定。
</p> <p>
根据市场状况，甲方的投资组合在有必要时，由乙方负责做出调仓建议，并组织实施调仓流程，具体实施和复核监控。乙方应当审慎评估调仓行为对流动性的影响。为保护投资者利益，乙方遵循底层资产长期配置原则，不进行频繁调仓。乙方提供的所有组合策略的年度最高周转率不得超过200%，达到180%时触发预警报告机制，若乙方拟上调最高周转率，应当事前报告有关监管部门。
</p> <p>
为确保组合调仓规范准确实施，乙方制定了组合调仓内部流程，并通过增加复核、运营监控避免操作风险。
</p> <p>
第四条 投资者适当性管理执行情况
</p> <p>
为规范公司销售行为，确保投资者适当性管理制度的有效落实，保护投资者合法权益，乙方根据《证券投资基金法》、《公开募集证券投资基金销售机构监督管理办法》、《证券期货投资者适当性管理办法》、《基金募集机构投资者适当性管理实施指引（试行）》等相关法律法规、自律规则，制定了《上海华夏财富投资管理有限公司投资者适当性管理暂行办法》。
</p> <p>
乙方应当遵守法律、行政法规、公司管理制度及其他有关规定，在销售产品或者提供服务的过程中，勤勉尽责，审慎履职，全面了解投资者情况，深入调查分析产品或者服务信息，科学有效评估，充分揭示风险，基于投资者的不同风险承受能力以及产品或者服务的不同风险等级等因素，提出明确的适当性匹配意见，将合适的产品或者服务推介给合适的投资者。但该适当性匹配意见并不表明乙方对投顾服务的风险和收益做出实质性判断或保证。
</p> <p>
甲方了解并认识到，乙方根据自身或其指定的成份基金销售机构提供的甲方的风险测评结果，向甲方提供基金投资组合策略建议和基金产品的投资决策。为此，甲方应审慎完成风险测评并向指定的成份基金销售机构提供真实、准确、完整的信息，并在该等信息涉及重大变化时及时通知该基金销售机构。甲方在此确认，甲方应自行承担因未履行上述义务而产生的任何损失或不利后果。
</p> <p>
第五条 投资顾问的职责和禁止行为
</p> <p>
（一）投资顾问的职责
</p> <p>
乙方应按照本协议约定的业务规则、投资者适当性管理、投资建议流程、调仓管理、利益冲突、风险控制措施、信息披露等内容，代甲方办理投顾账户开立、自行或通过成份基金销售机构基金交易账户开立、组合购买、组合调仓、成份基金的认/申购、赎回或转换等有关基金投资顾问业务。
</p> <p>
（二）投资顾问的禁止行为
</p> <p>
乙方及投资顾问人员不得有下列行为：
</p> <p>
1、利用基金投资顾问业务从事违法、违规行为，或提供便利；
</p> <p>
2、泄露客户资料、投资计划和交易情况；
</p> <p>
3、从事非公平交易、利益输送等损害甲方合法权益的行为；
</p> <p>
4、向甲方承诺收益，承诺本金不受损失或者限定损失金额或比例；
</p> <p>
5、其他损害甲方合法权益的行为。
</p> <p>
6、其他法律法规、规范性文件规定及本协议约定的禁止行为。
</p> <p>
第六条 收费项目、标准和支付方式
</p> <p>
1、投资顾问服务费
</p> <p>
投资顾问服务费按投顾账户各类组合的资产净值的一定比例加总收取，具体费率标准详见本协议所附各基金投资组合的《组合策略说明书》。
</p> <p>
按资产净值的一定比例收取投资顾问服务费的计算方法如下：
</p> <p>
H＝E×R÷当年天数
</p> <p>
H为每日应计提的投资顾问服务费
</p> <p>
E为前一日投顾账户资产净值
</p> <p>
R为各类组合适用的年投资顾问服务费率
</p> <p>
每一组合的投资顾问服务费加总后为投顾账户中各类组合的全部投资顾问服务费。投资顾问服务费每日计提，按月支付或全部及部分赎回时支付，按月支付的，每月结束后五个工作日内收取，《组合策略说明书》另有约定的除外。甲方同意乙方可采用资金划转或基金份额过户等监管部门认可的形式实现投资顾问服务费的收取。若采用基金份额过户形式的，甲方同意并授权乙方或其指定的成份基金销售机构赎回甲方应支付的基金投顾服务费等额的货币基金份额，并将上述货币基金份额过户至乙方账户，乙方可赎回上述货币基金份额，上述货币基金份额赎回的资金作为应支付的基金投顾服务费对应的金额。以上相关指令执行结果由甲方承担。
</p> <p>
乙方有权根据监管规定和市场情况，对上述投资顾问服务费实施费率优惠或调整，具体以乙方通过乙方或成份基金销售机构网站、移动终端（APP）公告等方式通知甲方。
</p> <p>
2、申购费、赎回费、转换费及基金销售费用
</p> <p>
组合中成份基金的申购费、赎回费、转换费及基金销售费用由甲方承担，收费标准和收取方式以成份基金销售机构系统设置为准。
</p> <p>
第七条 基金投资组合策略
<p> </p>
详见《组合策略说明书》。
</p> <p>
第八条 利益冲突
</p> <p>
为防范利益冲突，在投资建议机制上，乙方设立投资决策委员会，与母公司华夏基金投资部门、乙方其他部门相互隔离。投资决策委员会独立审议基金备选库入库名单，审议基金投资组合策略的产生和调整并评估形成基金投资组合策略的风险特征，审议基金投资组合策略的具体产品品种、数量的确定及调整；在监控机制上，通过风险管理部门进行投资程序和投资限制的监控，并集中对基金备选库进行管理。
</p> <p>
乙方在提供基金投资顾问建议过程中，应客观、独立形成建议方案，认真执行公平交易制度，按照规定对特殊交易履行审批或备案手续。乙方应对各投资组合的投资管理进行定期检查和评估，分析是否存在违背公平交易原则的异常情况。
</p> <p>
乙方通过基金投资组合建议甲方投资于乙方或关联方管理的产品的，应事先告知甲方，并向甲方充分披露潜在利益冲突；在备选库流程上，对关联方和其他基金管理人管理的成份基金采用同一标准。
</p> <p>
乙方同时作为组合成份基金的销售机构，可能与本协议项下的基金投资顾问业务构成利益冲突。为防范基金投资顾问业务与基金销售业务部门等可能存在的利益冲突，乙方将采取相应措施保障基金投资顾问业务的独立与隔离，防范因其他业务影响基金投资顾问业务的稳健运行。
</p> <p>
乙方声明、保证和承诺，提供基金投资顾问服务，应以投资者利益至上，公平对待客户。当出现利益冲突时，乙方不得为公司及其关联方的利益损害投资者利益，不得为乙方投资顾问人员及其利益相关者的利益损害甲方利益，不得为特定客户利益损害其他客户利益。乙方保证其不会直接或间接参与内幕交易、操纵证券交易价格或通过投资组合进行非法利益输送。
</p> <p>
乙方可以委托其母公司华夏基金参与基金配置建议的投资决策，为乙方的基金投顾服务提供投资研究支持。
</p> <p>
第九条 风险控制措施
</p> <p>
根据基金投资顾问业务的特点，乙方建立了合规风险防控体系，维护业务稳定运行。具体风险控制措施如下：
</p> <p>
（一）操作风险
</p> <p>
1、资金监管
</p> <p>
组合资金交收全过程在基金销售结算资金监管行的监督下进行，确保甲方资金同卡进出，通过闭环操作保障甲方资金安全，防范资金交收和洗钱风险。
</p> <p>
2、账户授权管理
</p> <p>
甲方按基金销售有关规定开立的基金交易账户作为其基金投资顾问业务的授权账户。
</p> <p>
3、调仓管理
</p> <p>
组合调仓方案由乙方出具并组织实施，通过独立的部门、人员、系统隔离防范利益冲突，并通过内部流程和系统控制降低操作风险。
组合调仓期间乙方负责对交易申请、确认、清算、资金划转等业务流程的运行状态进行监控；乙方负责对系统状况、服务器负载情况等进行实时监控，及时发现并处理异常情况，确保系统正常运转。
</p> <p>
4、应急预案
</p> <p>
为规避异常情况导致的业务风险，针对底层基金暂停、申购失败、资金交收失败、系统故障等情形，乙方制定有相应的应急处理预案。
</p> <p>
（二）组合市场风险管理
</p> <p>
1、组合投资限制
</p> <p>
投资组合在投资方面需要符合以下要求：
</p> <p>
（1）基金投资顾问服务的单个客户持有单只基金的市值，不得高于客户账户资产净值的20%，货币市场基金、指数基金不受此限。
</p> <p>
（2）单一基金投资组合策略下所有客户持有单只基金的份额综合不得超过该基金总份额的20%，持有指数基金的份额总和不得超过该基金总份额的30%。
</p> <p>
（3）单一基金投资组合策略下所有客户单日赎回单只基金的份额总和原则上不超过该基金总份额的5%。
</p> <p>
（4）不得向投资者建议结构的基金，包括分级基金场内份额和监管部门认定的其他基金。
</p> <p>
（5）建议投资者投资于封闭运作基金、定期开放基金等流通受限基金的，应当制定专门的风险管理制度，向投资者特别提示风险。向普通投资者建议投资流通受限基金的，应当事先取得投资者同意，且确认流通受限基金的投资期限与投资者的目标投资期限不存在冲突。
因证券市场波动、基金规模变动等基金投资组合策略之外的因素导致不符合上述要求，应当在3个月内调整，经监管部门认可的情形除外。
</p> <p>
2、市场风险监控
</p> <p>
乙方每日对各组合的盈亏情况、波动率、回撤、底层基金的相关性、底层基金盈亏情况、底层基金的风险占比进行监控。每季度对组合和市场情况进行回顾和调整，确保各组合始终符合既定投资目标。乙方在必要时方进行调仓。
</p> <p>
3、模型风险控制
</p> <p>
在资产配置和基金选择过程中，乙方采用定性为主、量化工具辅助的策略。组合资产配置和调仓建议主要依赖于乙方对宏观经济、估值、政策的判断以及投研人员的调研得到，并不完全依赖于算法程序，模型风险可控。
</p> <p>
4、流动性风险管理
</p> <p>
持续监控各组合及对应底层基金的认/申购、赎回情况，包括组合调仓期间对底层基金规模变化的影响，及时评估和监测各底层基金的流动性风险。
</p> <p>
5、组合业绩分析和绩效归因
</p> <p>
乙方每月对组合进行业绩分析，计算组合风险调整的收益指标，如夏普比率、回撤、波动率等；通过收益归因模型月度对组合的业绩进行归因分析。
</p> <p>
（三）利益冲突风险防范
</p> <p>
为防范基金投资顾问业务与基金销售业务部门等可能存在的利益冲突，乙方将采取相应措施保障投顾业务的独立与隔离，防范因其他业务影响投顾业务的稳健运行。在投资建议机制上，乙方独立设立产品部门，与母公司华夏基金投资部门、乙方其他部门相互隔离，独立提供基金投资建议。在监控机制上，通过风险管理部门进行投资程序和投资限制的监控，并集中对基金备选库进行管理。
</p> <p>
为防范利益冲突，乙方在提供基金配置建议过程中，客观、独立形成建议方案，认真执行公平交易制度，按照规定对特殊交易履行审批或备案手续。乙方应对各投资组合的投资管理进行定期检查和评估，分析是否存在违背公平交易原则的异常情况。乙方将按照乙方产品部的组合建议方案为甲方下单申购、赎回组合成份基金，或代甲方向成份基金销售机构出具申购、赎回组合成份基金指令，为避免重复收费，保护甲方利益，在申购、赎回组合中的成份基金时，将不收取成份基金计入基金资产外的申购、赎回费用。
</p> <p>
尽管本协议另有规定，母公司华夏基金有权参与基金配置建议的投资决策，为乙方的基金投顾服务提供投资研究支持。
</p> <p>
第十条 信息披露
</p> <p>
为确保甲方充分知悉所办理的投资顾问业务情况，乙方将在网站和移动终端（APP）披露投资组合的投资目标、投资策略、基金备选库明细、业绩比较基准、费率结构、风险收益特征、风险揭示等信息。
</p> <p>
在日常运作信息方面，将每日披露上一交易日组合收益率、账户收益率、账户资产净值情况。
</p> <p>
在定期报告方面，每季度披露年化收益率和季度收益率、组合运作分析、资产组合情况、成份基金构成及占比、本期调出调入成份基金记录以及当期交易及持有基金产生的费用，并按每季的频率向客户发送账户持仓、交易记录等信息，并就是否全面根据协议相关约定进行交易操作、是否存在执行偏差、交易策略调整等进行专项说明。
</p> <p>
在临时信息披露方面，若发生影响甲方利益的重大事件，将及时通过网站和移动终端（APP）上披露临时公告。
</p> <p>
乙方根据本协议在网站和移动终端（APP）上，披露账户收益、持仓、交易记录等信息，披露频率如下：
</p> <p>
（1）账户收益：T+1日向甲方披露其账户收益；
</p> <p>
（2）持仓：每季度向甲方披露其持仓信息；
</p> <p>
（3）交易记录：实时披露甲方交易记录。
</p> <p>
甲方可通过拨打乙方客服电话方式获取持仓情况和交易明细。
</p> <p>
乙方保证甲方能够按照法规规定及本协议上述约定的时间和方式查询账户信息。发生可能影响客户权益的重大事项时，应当自重大事项发生之日起2日内，按照本协议约定的方式，向甲方进行披露。
</p> <p>
甲方可对乙方履行上述信息披露情况实施监督。
</p> <p>
第十一条 违约责任
</p> <p>
本协议任何一方因故意或过失违反本协议的约定，给另一方造成损失的，应承担相应的违约责任。如属双方违约，由双方分别承担各自应负的责任。乙方与成份基金销售机构分别对各自的行为依法承担责任。
</p> <p>
第十二条 法律适用
</p> <p>
（一）本协议的成立、生效、履行和解释，均适用中华人民共和国法律；法律无明文规定的，可适用通行的行业惯例。
</p> <p>
（二）如果本协议的部分规定与有关的法律法规或金融规章相抵触，双方应按有关的法律法规或金融规章的规定履行自己的权利义务，协议的其他部分的效力不受影响。
</p> <p>
（三）关于本协议的未尽事宜，双方同意按照乙方及乙方指定的成份基金销售机构的有关规定和金融监管规章的规定办理。
</p> <p>
第十三条 争议的解决
</p> <p>
本协议履行地为北京市，甲、乙双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均可向北京仲裁委员会提起仲裁。仲裁裁决是终局的，对双方均具有约束力。
</p> <p>
笫十四条 协议适用
</p> <p>
本协议未作约定的，以乙方及乙方指定的成份基金销售机构制定并不时更新的业务规则为准。
</p> <p>
第十五条 协议签署、变更与解除
</p> <p>
甲方签署本协议即表明甲方已经仔细阅读本服务协议各项内容，清楚双方的权利义务，愿意通过电子信息网络以电子形式签署相关文件并承担相关签约后果。
</p> <p>
本协议自甲方签署协议时生效。甲方于网站、移动终端（APP）上确认本协议内容、输入专有的账户密码即为协议签署，与甲方纸质文件上签名具有同等效力。
</p> <p>
乙方可以根据监管部门有关要求、行业协会有关指引、实际情况和业务需要变更本协议具体内容，发生变更的，乙方将在网站、移动终端（APP）或营业场所公告或以其他适当方式通知，而无需另行单独通知投资者；投资者在公告后继续使用基金投资顾问业务的，视为接受该变更。
</p> <p>
本协议应持续有效，除非任何一方在以下情形提前解除：
</p> <p>
（一）若任何一方出现以下情形，任何一方有权在提前通知的前提下随时立即终止本协议：
</p> <p>
1、违反本协议规定的义务且未能及时补救；或
</p> <p>
2、破产（为重组或合并目的进行的自愿清算除外）或其发生财产接管的；或
</p> <p>
3、乙方开展基金投资顾问业务的资格被暂停或撤销；或
</p> <p>
4、根据法律法规、监管要求解除的；及
</p> <p>
（二）甲方有权根据乙方页面提示的操作步骤随时终止本协议。
</p> <p>
本协议解除或终止后，乙方不再为甲方的投资组合提供授权管理服务，甲方应自行决定投资组合内的成份基金是否赎回或进行其他调仓操作。本协议解除或终止前乙方已经收取的投资顾问服务费不予退还。
</p> <p>
笫十六条 送达
</p> <p>
甲方同意，就任何关于投资、资金支付或收取、权利义务转让、签约、协议条款更新等内容的通知，任何关于人民法院诉讼文件、执行文件的送达，乙方可选择通过以下方式进行告知或送达:
</p> <p>
（一）通过乙方公告、站内信等方式公示，自乙方公示内容发布之日起满1个工作日，视为送达成功;
</p> <p>
（二）通过甲方预留的电子邮件、手机短信方式传送，自送达内容由乙方邮箱系统或短信系统发出之时，视为送达成功;
</p> <p>
（三）以常规的信件方式邮寄，自信件邮戳日期起满四个工作日视为送达。
</p> <p>
若因甲方地址、名称等联系方式有误或有变更而未书面通知乙方，或信息系传输故障等原因导致甲方未收到该等通知的，乙方不承担责任。
</p> <p>
第十七条 特别提示
</p> <p>
乙方作为公开募集证券投资基金投资顾问业务的试点机构，根据《通知》的要求，特别提示甲方如下信息：
</p> <p>
1、乙方业务推广、客户招揽、了解客户等业务环节的人员不得向客户提供未经投资决策委员会审议的基金投资组合策略或擅自变更基金投资组合策略。
</p> <p>
2、甲方自行承担投资风险：本协议不免除乙方诚实守信、谨慎勤勉义务的条款，甲方享有随时终止服务的权利。
</p> <p>
甲方同意签署本协议视为同意并签字确认附件《特别提示确认》。
</p> <p>
第十八条 其他
</p> <p>
乙方对本协议拥有修改权，修改本协议或本协议条款的通知将通过乙方或乙方指定成份基金销售机构的网站和移动终端（APP）或其他方式告知甲方。甲方申请使用基金投资顾问服务前均需签署本协议内容，若甲方不认可本协议内容及其后续修改部分，则甲方应当立即停止使用基金投资顾问业务，否则即表示甲方认可相关协议内容，并接受协议条款约束。
</p> <p>
附件：
</p> <p>
特别提示确认
 
</p> <p>
上海华夏财富投资管理有限公司（以下简称“华夏财富”）作为公开募集证券投资基金投资顾问业务的试点机构，根据《关于做好公开募集证券投资基金投资顾问业务试点工作的通知》（中国证券监督管理委员会机构部函[2019]2515号）的有关要求，特别提示投资者如下信息：
</p> <p>
1、华夏财富业务推广、客户招揽、了解客户等业务环节的人员不得向客户提供未经投资决策委员会审议的基金投资组合策略或擅自变更基金投资组合策略。
</p> <p>
2、投资者自行承担投资风险：《上海华夏财富投资管理有限公司基金投资顾问服务协议》不免除华夏财富诚实守信、谨慎勤勉义务的条款，投资者享有随时终止服务的权利。
</p> <p>本人作为投资者，确认已知悉上述特别提示的有关内容。
 
                </p>
            </div>

          </div>
          <div className="qy_FixedBottomNot">
            <div onClick={()=>{ this.handleCancel() }}>
              <div style={{ color:"#5c6270", fontSize:'10px'}}>取消</div>
            </div>
            <div onClick={()=>this.signSuperAccAgreement()}> 同意签约 </div>
          </div>

        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    webViewHtml:state.webViewHtml
  }
}
export default connect(mapStateToProps)(SuperFundSigning);



// WEBPACK FOOTER //
// ./src/components/SuperFundSigning.js